module.exports = __webpack_public_path__ + "static/media/CC20-AP070-12.b2505f12.png";